import { LocationService } from "@common/_services";
import * as React from "react";

import { SearchEntry, SearchEntryProps } from ".";

interface SearchLocationsProps extends SearchEntryProps {
    includeAll?: boolean;
}

export class SearchLocations extends React.Component<SearchLocationsProps> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props: SearchLocationsProps) {
        super(props);
        this.getLocations = this.getLocations.bind(this);
    }

    static defaultProps = {
        includeAll: false,
        label: "locations",
        name: "searchLocations",
        options: [],
        submitOnEnter: false,
    };

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key =>
                abortControllers[key].abort()
            );
        }
    }

    getLocations(term) {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.suggestLocations) {
            this._abortControllers.suggestLocations.abort();
        }
        this._abortControllers.suggestLocations = new AbortController();
        const signal = this._abortControllers.suggestLocations.signal;

        return LocationService.suggestLocations(
            term,
            false,
            true,
            signal
        ).then(json =>
            json.results.map(x => ({ label: x.item_name, value: x.item_id }))
        );
    }

    render() {
        return (
            <SearchEntry
                {...this.props}
                showIcon={false}
                isTypeAhead={true}
                dataCy={this.props.dataCy}
                getRemoteOptions={this.getLocations}
            />
        );
    }
}
